import useBusinessPostApi from '~/lib/useBusinessPostApi.js';

const RetrySubscriptionPaymentButton = ({ refetch, grantId, className }) => {
    const { save, isSaving } = useBusinessPostApi(
        `/packages/grant/${grantId}/retry-payment`,
    );

    return (
        <div className={className}>
            <button
                type="button"
                onClick={() => save().then(() => refetch())}
                className="btn-light-pill-sm uppercase"
            >
                {isSaving ? 'Retrying...' : 'Retry Payment'}
            </button>
        </div>
    );
};

export default RetrySubscriptionPaymentButton;
